import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

import { required } from 'Shared/utils/formValidations';
import FormEmailsSelection from 'Shared/components/FormComponents/FormEmailsSelection';
import { billingStates } from 'Shared/constants/constants';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import PersonalMessageForm from './PersonalMessageForm/PersonalMessageForm';

import './InviteTeammatesFormFields.scss';

function InviteTeammatesFormFields() {
  const freeTrialActive = useSelector(state => state.organization.billingState === billingStates.FREE_TRIAL);
  const { tr } = useTranslation();

  return (
    <div className="InviteTeammatesFormFields d-flex flex-column">
      <div className="mb-2">{tr('perform.sync_meetings.invite_teammates.header')}</div>
      {freeTrialActive && (
        <div className="InviteTeammatesFormFields__highlight-description mb-2">
          {tr('perform.sync_meetings.invite_teammates.trial_extension')}
        </div>
      )}
      <FormEmailsSelection selector="inviteeEmails" />
      <Field name="personalMessage" component={PersonalMessageForm} validate={required} />
    </div>
  );
}

export default InviteTeammatesFormFields;
